// MikaMotioon Theme JS

// Landing splash — enter site
function enterSite(lang) {
  var splash = document.getElementById('landing-splash');
  if (splash) {
    splash.classList.add('hidden');
    setTimeout(function(){ splash.style.display = 'none'; }, 700);
    localStorage.setItem('mm_lang', lang);
  }
}
// Skip splash if user has already chosen
if (localStorage.getItem('mm_lang')) {
  var s = document.getElementById('landing-splash');
  if (s) s.style.display = 'none';
}

// Nav scroll
window.addEventListener('scroll', function() {
  var nav = document.getElementById('main-nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 80);
});

// Reveal on scroll
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(function(el) { observer.observe(el); });

// PT tabs
function switchTab(e, tab) {
  document.querySelectorAll('.pt-tab').forEach(function(t){ t.classList.remove('active'); });
  document.querySelectorAll('.pt-content').forEach(function(c){ c.classList.remove('active'); });
  e.target.classList.add('active');
  var target = document.getElementById('tab-' + tab);
  if (target) target.classList.add('active');
}

// Pack select
function selectPack(el) {
  el.closest('.pack-row').querySelectorAll('.pack-option').forEach(function(p){ p.classList.remove('selected'); });
  el.classList.add('selected');
}

// Radio labels
document.querySelectorAll('.form-radio-label').forEach(function(label) {
  label.addEventListener('click', function() {
    var name = label.querySelector('input') ? label.querySelector('input').name : null;
    if (!name) return;
    document.querySelectorAll('input[name="' + name + '"]').forEach(function(inp){
      inp.closest('.form-radio-label').classList.remove('checked');
    });
    label.classList.add('checked');
  });
});

// Form submit
function submitForm(type) {
  var body = document.getElementById(type + '-form-body');
  var success = document.getElementById(type + '-success');
  if (body) body.style.display = 'none';
  if (success) success.style.display = 'block';
}

// Modal close on overlay click
document.querySelectorAll('.modal-overlay').forEach(function(overlay) {
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) overlay.classList.remove('open');
  });
});

// Cart add button
document.querySelectorAll('.product-form form').forEach(function(form) {
  form.addEventListener('submit', function(e) {
    // Shopify handles this natively via action="/cart/add"
  });
});
